import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'agilityPercent'
})
export class AgilityPercentPipe implements PipeTransform {

  transform(value: number): number | string {
    return isNaN(value) ? value : (value < 1) ? `${Math.trunc(value * 100)}%` : `${value}%`;
  }

}
